import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const InvestorMetaTags: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const isInvestorPwa = location.pathname.startsWith('/investor-pwa');
    if (!isInvestorPwa) return;

    const updateMetaTag = (property: string, content: string, isProperty = true) => {
      const selector = isProperty ? `meta[property="${property}"]` : `meta[name="${property}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;

      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) {
          meta.setAttribute('property', property);
        } else {
          meta.setAttribute('name', property);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    const updateLinkTag = (rel: string, href: string, sizes?: string) => {
      const selector = `link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ''}`;
      let link = document.querySelector(selector) as HTMLLinkElement;

      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', rel);
        if (sizes) {
          link.setAttribute('sizes', sizes);
        }
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    };

    document.title = 'Mavrk Investor';
    updateMetaTag('title', 'Mavrk Investor', false);
    updateMetaTag('description', 'Investor portfolio access for Mavrk.', false);
    updateMetaTag('og:title', 'Mavrk Investor');
    updateMetaTag('og:description', 'Investor portfolio access for Mavrk.');
    updateMetaTag('twitter:title', 'Mavrk Investor');
    updateMetaTag('twitter:description', 'Investor portfolio access for Mavrk.');
    updateMetaTag('theme-color', '#000000', false);
    updateMetaTag('apple-mobile-web-app-capable', 'yes', false);
    updateMetaTag('apple-mobile-web-app-status-bar-style', 'black-translucent', false);
    updateMetaTag('apple-mobile-web-app-title', 'Mavrk Investor', false);
    updateMetaTag('mobile-web-app-capable', 'yes', false);

    updateLinkTag('manifest', '/investor-manifest.json');
    updateLinkTag('apple-touch-icon', '/pwa-192x192.png', '192x192');
    updateLinkTag('apple-touch-icon', '/pwa-512x512.png', '512x512');
  }, [location.pathname]);

  return null;
};

export default InvestorMetaTags;
